var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg" },
    [
      _c("v-card", { attrs: { "max-width": "300" } }, [
        _c(
          "div",
          { staticClass: "px-10 py-5 d-flex flex-column align-center" },
          [
            _c("h2", { staticClass: "mb-5" }, [
              _vm._v("Imposta il tuo username:"),
            ]),
            _vm._v(" "),
            _c("v-text-field", {
              attrs: {
                label: "Username",
                name: "displayNameNew",
                required: "",
              },
              model: {
                value: _vm.displayNameNew,
                callback: function ($$v) {
                  _vm.displayNameNew = $$v
                },
                expression: "displayNameNew",
              },
            }),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "pa-4 white--text",
                attrs: {
                  depressed: "",
                  disabled: _vm.displayNameNew.length == 0,
                  color: "secondary",
                },
                on: { click: _vm.save },
              },
              [_vm._v("Conferma")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }